// extracted by mini-css-extract-plugin
export var searchHeader = "_a7-0";
export var searchHeaderDark = "_a7-1";